export function useMentions() {
  const getMentionTriggerInfo = (textarea, cursorPosition) => {
    const text = textarea.value;
    const textBeforeCursor = text.substring(0, cursorPosition);
    
    const lastAtIndex = textBeforeCursor.lastIndexOf('@');
    
    if (lastAtIndex === -1) {
      return null;
    }
    
    const charBeforeAt = lastAtIndex > 0 ? textBeforeCursor[lastAtIndex - 1] : ' ';
    if (charBeforeAt !== ' ' && charBeforeAt !== '\n' && lastAtIndex !== 0) {
      return null;
    }
    
    const searchQuery = textBeforeCursor.substring(lastAtIndex + 1);
    
    if (searchQuery.includes('\n') || 
        searchQuery.includes(' ') ||
        /\s[^a-zA-Z]/.test(searchQuery)) {
      return null;
    }
    
    if (searchQuery.length > 50) {
      return null;
    }
    
    return {
      startIndex: lastAtIndex,
      endIndex: cursorPosition,
      searchQuery: searchQuery.trim(),
      rawQuery: searchQuery,
      isActive: true
    };
  };
  
  const getCaretPosition = (textarea) => {
    return textarea.selectionStart;
  };
  
  const insertMention = (textarea, mentionInfo, user) => {
    const text = textarea.value;
    const mention = `@${user.display_name}`;
    
    const beforeMention = text.substring(0, mentionInfo.startIndex);
    const afterMention = text.substring(mentionInfo.endIndex);
    const newText = beforeMention + mention + ' ' + afterMention;
    
    textarea.value = newText;
    
    const newCursorPos = beforeMention.length + mention.length + 1;
    textarea.setSelectionRange(newCursorPos, newCursorPos);
    
    const event = new Event('input', { bubbles: true });
    textarea.dispatchEvent(event);
    
    return {newText , id: user.ID};
  };
  
  const extractMentionsFromText = (text) => {
    const mentionRegex = /@([a-zA-Z0-9_\s]+?)(?=\s|$|[^\w\s])/g;
    const mentions = [];
    let match;
    
    while ((match = mentionRegex.exec(text)) !== null) {
      mentions.push({
        fullMatch: match[0],
        username: match[1].trim(),
        startIndex: match.index,
        endIndex: match.index + match[0].length
      });
    }
    
    return mentions;
  };
  
  const convertMentionsToLinks = (text) => {
    return text.replace(/@([a-zA-Z0-9_\s]+?)(?=\s|$|[^\w\s])/g, (match, username) => {
      const cleanUsername = username.trim();
      return `<span class="user-mention" data-username="${cleanUsername}">@${cleanUsername}</span>`;
    });
  };
  
  const stripHTML = (text) => {
    if (!text) return '';
    return text.replace(/<[^>]*>/g, '');
  };
  
  return {
    getMentionTriggerInfo,
    getCaretPosition,
    insertMention,
    extractMentionsFromText,
    convertMentionsToLinks,
    stripHTML
  };
}
